import { keyframes } from "styled-components";


export const keyframePulse = keyframes`
	0% {
		transform: scale(1.1);
	}
	7% {
		transform: scale(0.9);
	}
	
	14% {
	 transform: scale(1.1);
	}
	
	100% {
	  transform: scale(1.1);
	}
`;
